// Module
var code = " <h2>Assignment 4 description</h2> <p>Submit:</p> <ol> <li>Your timeline</li> </ol> ";
// Exports
export default code;